<script setup lang="ts">
import { initLegalAccountForm } from '../../../../utilities/account/useAccountFormLegal'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import BaseInputText from '../../../base/BaseInputText.vue'
import { CreditCardIcon } from '@heroicons/vue/solid'
import {
    isRequiredLegalProfileAttributesForInvestment,
    isRequiredRequiredLegalProfileAttributes,
} from '../../../../validation'
import { navigateTo } from '../../../../utilities/account/useAccountNavigationLegal'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { getIsIbanFromBankAccount } from '../../../../utilities/usePlatformSettings'

const { legalProfile } = useLegalAccountDataState()

initLegalAccountForm('Bank Data')

function goToBankVerification() {
    navigateTo('Verification', 'kyc_bank')
}
</script>

<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 px-4 py-5 sm:grid-cols-2 sm:px-6">
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.iban"
                :icon="CreditCardIcon"
                :required="isRequiredRequiredLegalProfileAttributes('iban')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('iban')"
                :disabled="getIsIbanFromBankAccount()"
                name="legal_account.iban"
                :label="$t('legal_account.iban')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.bic"
                :icon="CreditCardIcon"
                :required="isRequiredRequiredLegalProfileAttributes('bic')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('bic')"
                :disabled="getIsIbanFromBankAccount()"
                name="legal_account.bic"
                :label="$t('legal_account.bic')" />
        </div>
    </div>

    <div v-if="getIsIbanFromBankAccount()" class="px-4 py-5 sm:px-6">
        <div class="items-center justify-between space-y-2 md:flex md:space-y-0">
            <p class="max-w-md pt-1 text-xs text-gray-400">
                {{ $t('bank_data.iban_from_bank_account_notice') }}
            </p>
            <BaseButtonMuted size="lg" class="w-full whitespace-nowrap sm:w-auto" @click="goToBankVerification">
                {{ $t('bank_data.iban_from_bank_account_link_button') }}
            </BaseButtonMuted>
        </div>
    </div>
</template>
